import { useCallback, useRef, useState } from "react";
import { t } from "i18next";
import { useTheme } from "../../stores";
import { TriggerMenu } from "../TriggerMenu";
import * as UI from "@smartsuite/react-ui/lib";
import * as S from "./styles";
import PlusIcon from "../../../generated/images/Plus";
import { Colors, SolutionColorVariables } from "@smartsuite/types";
import { useFlowCanvasMenuDismiss } from "../FlowCanvas/hooks/use-flow-canvas-menu-dismiss";

export const AddTriggerButton: React.FC<{
  label: string;
  showError: boolean;
  onClick: (integrationId: string, triggerId: string) => void;
}> = ({ label, showError, onClick }) => {
  const theme = useTheme();
  const btnRef = useRef(null);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(true);
  useFlowCanvasMenuDismiss(useCallback(() => setIsMenuOpen(false), []));

  return (
    <>
      <S.Button
        ref={btnRef}
        isActive={isMenuOpen}
        borderColor={theme.primaryColor}
        onClick={() => setIsMenuOpen((isOpen) => !isOpen)}
      >
        <S.Content>
          <PlusIcon
            style={{ marginRight: "13px" }}
            fill={SolutionColorVariables.sc1}
          />{" "}
          {label}
        </S.Content>
        <S.WarningIcon>
          {showError && (
            <UI.Tooltip
              placements={["top"]}
              text={t("automation-form.trigger-not-selected")}
              target={
                <UI.Icon
                  size={"M"}
                  name={"important-lined"}
                  color={Colors.bRed}
                  width={26}
                  height={26}
                />
              }
            />
          )}
        </S.WarningIcon>
      </S.Button>
      <TriggerMenu
        menuButtonRef={btnRef}
        isMenuOpen={isMenuOpen}
        setMenuOpen={setIsMenuOpen}
        onTriggerChange={onClick}
        showOnboarding
      />
    </>
  );
};
